module.exports = __webpack_public_path__ + "img/close-banner-icon.06914976.svg";